import React, { createRef } from 'react'
import WbHttpClient from '../../services/wbhttpclient'
import debounce from 'lodash/debounce'
import axios from 'axios'
import ImgIconComp from '../../components/imgcomp'
import { uniqueArrayObject } from '../../utils/function'

var CancelToken = axios.CancelToken
const ALIGN_KR_TYPE = 'allign_kr'
const MIRROR_KR_TYPE = 'mirror_kr'
const ROLLUP_KR_TYPE = 'rollup_kr'
const ROLLUP_OKR_TYPE = 'rollup_okr'
const CASCADE_KR_TYPE = 'cascade_kr'

const LoaderComp = function (props) {
  return (
    <div className="loading-comp">
      <ImgIconComp id="loadinggif" />
    </div>
  )
}

export default class SearchBoxComp extends React.Component {
  constructor(props) {
    //console.log('THIS PROPS IN SEARCH BOX', props);
    super(props)
    this.state = {
      searchValue: '',
      values: [],
      showDropdown: this.props.dropdown || false,
      selectedItem: this.props.defaultDropdownValue || '',
      expandInputClass: '',
      totalCount: 0,
      loading: false,
    }
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.clickShowInutBox = this.clickShowInutBox.bind(this)
    this.closeBox = this.closeBox.bind(this)
    this.updateSelectedItem = this.updateSelectedItem.bind(this)
    // use underscore libaray
    this.changeSearchBox = this.changeSearchBox.bind(this)
    this.delayedCalleback = debounce(function(e) {
      this.setState({ searchValue: e.target.value },
        () => this.searchRequest(e)
      )
    }, 300)
    this.onFocusEvt = this.onFocusEvt.bind(this)

    this.WbHttpClient = new WbHttpClient()
    this.cancelRequest = null
    this.scrRef = createRef()
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    document.addEventListener('keydown', this.handleEscClick)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
    document.removeEventListener('keydown', this.handleEscClick)
  }

  clickShowInutBox() {
    this.setState({ showDropdown: false }, () => {
      this.searchText.focus()
    })
  }

  onFocusEvt(e) {
    if (this.props.expandSearchBox) {
      this.setState({ expandInputClass: ' borderbox expandsearchbox ' })
    }
  }

  updateSelectedItem(item) {
    this.setState({ showDropdown: true, selectedItem: item })
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.closeBox()
    }
  }

  handleEscClick = (event) => {
    if (
      event.keyCode === 27 &&
      this.wrapperRef
      // !this.wrapperRef.contains(event.target)
    ) {
      this.closeBox()
    }
  }

  closeBox() {
    if (this.searchText) {
      this.searchText.value = ''
    }
    let showDropdown = this.props.dropdown
    this.setState({
      values: [],
      searchValue: '',
      showDropdown,
      expandInputClass: '',
    })
  }

  //to be revisit
  handleScroll(e) {
    let mirrorScroll = true;
    this.setState({
      loading: true,
    })

    let element = e.target
    let query = {}
    if (element.scrollTop + element.clientHeight >= element.scrollHeight) {
      const pageLimit = 50
      query.offset = 0
      //console.log("this.state.value",this.state.values);
      let currentItems = 0
      if (this.props.type == ROLLUP_OKR_TYPE) {
        // console.log("Okrrr",this.props.type);
        currentItems = this.state.values.length
      } else if (
        this.props.type == ALIGN_KR_TYPE ||
        this.props.type == MIRROR_KR_TYPE ||
        this.props.type == ROLLUP_KR_TYPE ||
        this.props.type == CASCADE_KR_TYPE
      ) {
        this.state.values.forEach(function (ele) {
          if (typeof ele.metrics !== 'undefined' && ele.metrics) {
            currentItems += parseInt(ele.metrics.length)
          }
        })
      }

      const totalPage = Math.ceil(this.state.totalCount / pageLimit)
      let currentPage = Math.ceil(currentItems / pageLimit)
      query.offset = currentItems
      query.term = this.searchText.value
      query.pageLimit = pageLimit
      if (currentPage == totalPage || currentItems == this.state.totalCount) {
        // console.log("No pagination");
        this.setState({
          loading: false,
        })
        return
      }
      let _this = this
      const type = _this.props.type

      let params = Object.assign({}, this.props.params, query)
      if(this.props.type == MIRROR_KR_TYPE && _this.state.searchValue.length !== 0){
        mirrorScroll = false;
      }
      axios({
        method: 'get',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        url: wbConfig.baseUrl + '/' + this.props.url,
        cancelToken: new CancelToken(function executor(c) {
          _this.cancelRequest = c
        }),
        params: params,
      }).then((response) => {
        let values = []
        let data = []
        let items = this.state.values
        if (response.data) {
          if (
            (type == ALIGN_KR_TYPE ||
            type == MIRROR_KR_TYPE ||
            type == ROLLUP_KR_TYPE ||
            type == CASCADE_KR_TYPE) && mirrorScroll
          ) {

            response.data.data.metrics.map((item) => {
              const findGoal = items.find((i) => i.id == item.id)
              if (findGoal) {
                findGoal.metrics = uniqueArrayObject(
                  findGoal.metrics.concat(...item.metrics),
                  'id'
                )
              } else {
                items.push(item)
              }
              data = items
            })
          } else if (type == ROLLUP_OKR_TYPE) {
            data = uniqueArrayObject(
              items.concat(...response.data.data.goals),
              'id'
            )
          }
          values =
            _this.state.searchValue.length >= _this.props.minLength ? data : []
          if (_this.props.beforeFilterValues) {
            values = _this.props.beforeFilterValues(values)
          }
          _this.setState({
            ...values,
            values: values,
            loading: false,
          })
        }
      })
    }
    this.setState({
      loading: false,
    })
  }

  searchRequest(e) {
    const { searchValue = ''} = this.state;
    var v = searchValue ? searchValue.trim() : '';
    var url = this.props.url || ''
    let _this = this
    let compParams = this.props.params;
    if (v.length >= this.props.minLength && url) {
      if (_this.cancelRequest != null) {
        _this.cancelRequest()
      }
      const type = _this.props.type
      let nestedKrSearch = false;
      if(type == MIRROR_KR_TYPE){
        nestedKrSearch = true;
      }
      if(v.length > 0 && type == MIRROR_KR_TYPE){
        compParams = { }
      }
      axios({
        method: 'get',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        url: wbConfig.baseUrl + '/' + url,
        cancelToken: new CancelToken(function executor(c) {
          _this.cancelRequest = c
        }),
        params: { ...compParams, ...{ term: v , nestedKr : nestedKrSearch, excludeAIAgents : _this.props.excludeAIAgents } },
      }).then((response) => {
        let values = []
        let data = []
        let totalCount = 0
        if (response.data) {
          if (
            type == ALIGN_KR_TYPE ||
            type == MIRROR_KR_TYPE ||
            type == ROLLUP_KR_TYPE ||
            type == CASCADE_KR_TYPE
          ) {
            data = response.data.data.metrics
          } else if (type == ROLLUP_OKR_TYPE) {
            data = response.data.data.goals
          } else {
            data = response.data.data
          }
          values = v.length >= _this.props.minLength ? data : []
          totalCount = response.data.data.totalCount
            ? response.data.data.totalCount
            : 0

          if (_this.props.beforeFilterValues) {
            values = _this.props.beforeFilterValues(values)
          }
          // console.log('IN RESPONSE VAL', values);
        } else {
          values = []
          // console.log('IN RESPONSE ELSE VAL', values);
        }
        _this.setState({
          values:
            _this.props.goalId && _this.props.goalId != ''
              ? values.filter((val) => val.id != _this.props.goalId)
              : this.filterMetric(values),
          totalCount: totalCount,
        })
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          throw error
        }
      })
    } else if (this.props.customSearchUrl && this.props.customPromiseChain) {
      _this.props.customSearchUrl(v).then((res) => {
        console.log(res)
        _this.props.customPromiseChain(res, _this)
      })
    } else {
      //console.log('In the final else', this.state.values);
      this.setState({ values: [] })
    }
  }

  filterMetric = (values) => {
    if(values.length && values[0].metrics){
      values.map((goal, goalIndex)=>{
        values[goalIndex].metrics = goal.metrics.filter((metric, _metricIndex)=>{
          return (metric.id !== this.props.parentKRID && metric.id !== this.props.id)
        });
      });
    }
    return values;
  }

  changeSearchBox(e) {
    e.persist()
    if(e.target.type != "checkbox"){
      this.delayedCalleback(e);
    }
    //console.log('In Change Search Box', this.state.searchValue);
    if (document.getElementsByClassName('ui-tooltip-content').length > 0) {
      //console.log('FOUND TOOLTIP');
      // setTimeout( () => $(e.target).trigger("mouseleave"), 0) ;
      //$('.ui-tooltip-content').trigger("mouseleave");
      $('.ui-tooltip-content, .ui-tooltip').remove()
    }
  }

  renderSearchItem(v) {
    return <div className="searchboxcomp-item">{v.label}</div>
  }

  renderResults = () => {
    let values = this.state.values
    if (values.length > 0 && this.props.moveDropDownSearch) {
      $('.krRightPaneContent').parent().animate({ scrollTop: 250 })
    }
    if (this.props.renderResultComp) {
      return this.props.renderResultComp(values, this, this.props.listType)
    } else {
      return values.map((v) =>
        this.props.renderSearchItem
          ? this.props.renderSearchItem(v, this)
          : this.renderSearchItem(v)
      )
    }
  }

  uniqueValues(str = '') {
    if (str && str != null) {
      let strArray = str.split(' ')
      str = [...new Set(strArray)].join(' ')
    }
    return str
  }

  render() {
    let valuesLength = this.state.values.length ? true : false
    let inputProps = this.props.inputProps || {}
    let containerClassName =
      typeof this.props.containerClassName !== 'undefined'
        ? this.props.containerClassName
        : 'searchboxcomp-results borderbox'
    let inputClassName =
      'search-input-text ' +
      (typeof inputProps.className !== 'undefined' ? inputProps.className : '')
    let uniqueClassname = this.uniqueValues(inputClassName)
    inputProps.className = uniqueClassname
    const { searchBoxId } = this.props || {};
    const type = this.props.type
    return (
      <div
        ref={(node) => (this.wrapperRef = node)}
        data-testid="searchboxcomp-wrapper"
        {...(type == MIRROR_KR_TYPE ? {onClick : (e) => this.changeSearchBox(e)} : {})}
        className={
          'searchboxcomp-wrapper ' +
          this.props.wrapperClass +
          (valuesLength ? ' borderbox ' : '') +
          this.state.expandInputClass
        }
      >
        {this.state.showDropdown ? (
          <div
            className="selected-item-wrapper react-dropdown-box"
            onClick={() => this.clickShowInutBox()}
            ref={this.scrRef}
          >
            <div className="selected-item ">
              <div className="selected-text">
                {this.props.renderSelectedText ? (
                  this.props.renderSelectedText(this.state.selectedItem)
                ) : (
                  <div className="truncate">{this.state.selectedItem}</div>
                )}
              </div>
              <div className="icon icon-dropdown-14px dropdowncomp-icon"></div>
              <div className="clear"></div>
            </div>
          </div>
        ) : (
          <input
            type="text"
            ref={(input) => {
              this.searchText = input
            }}
            {...this.props.inputProps}
            id={searchBoxId || 'search-input-box'}
            // role="search"
            data-testid="search-input-box"
            onChange={(e) => this.changeSearchBox(e)}
            onFocus={(e) => this.onFocusEvt(e)}
            aria-invalid="false"
          />
        )}
        {valuesLength ? (
          <div
            className={containerClassName}
            data-testid="searchboxcomp-results"
            onScroll={this.handleScroll}
          >
            {this.renderResults()}
            {this.state.loading ? <LoaderComp /> : ''}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

SearchBoxComp.defaultProps = {
  wrapperClass: '',
  inputProps: {},
  url: '',
  excludeAIAgents: false,
  minLength: 0,
  renderResultComp: null,
  renderSearchItem: null,
  beforeFilterValues: null,
  dropdown: false,
  defaultDropdownValue: '',
  renderSelectedText: null,
  expandSearchBox: false,
  type: '',
}
